import {Button} from "@/components/ui/button.tsx";
import {ChevronLeft, ChevronRight} from "lucide-react";

type PaginationProps = {
    count: number;
    page: number;
    onChange: (page: number) => void;
};

function Pagination({ count, page, onChange }: PaginationProps) {
    const pages = Array.from({ length: count }, (_, i) => i + 1);

    function handlePrevious() {
        if (page > 1) {
            onChange(page - 1);
        }
    }

    function handleNext() {
        if (page < count) {
            onChange(page + 1);
        }
    }

    return (
        <div className="flex items-center gap-1">
            <Button
                variant="outline"
                size="icon"
                onClick={handlePrevious}
                disabled={page === 1}
            >
                <ChevronLeft className="h-4 w-4" />
            </Button>

            {pages.map(pageNum => (
                <Button
                    key={pageNum}
                    variant={page === pageNum ? "default" : "outline"}
                    size="sm"
                    onClick={() => onChange(pageNum)}
                >
                    {pageNum}
                </Button>
            ))}

            <Button
                variant="outline"
                size="icon"
                onClick={handleNext}
                disabled={page === count}
            >
                <ChevronRight className="h-4 w-4" />
            </Button>
        </div>
    );
}

export { Pagination };
